export default "/images/pen-tool.svg?a0a03aa00c6b2a2d5cd16ea79da6940c";